import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Results } from 'src/app/models/server/core/results-T';
import { FolderState } from 'src/app/models/server/folder-state';
import { ConnectedUsersStateService } from '../state/connected-users-state.service';
import { ServiceBase } from './service-base';

@Injectable({
    providedIn: 'root',
})
export class FolderStatesService extends ServiceBase {
    /**
     * Constructeur
     * */
    constructor(
        private http: HttpClient,
        public override connectedUserStateService: ConnectedUsersStateService
    ) {
        super(connectedUserStateService);
    }

    /**
     * Récupère la liste des états de dossier
     */
    public list(): Observable<FolderState[]> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        };

        return this.http.get<Results<FolderState>>(this.baseUrl + `/api/organizations/${this.organizationId}/foldersStates`, httpOptions).pipe(map((x) => x.value));
    }
}
